import React from 'react';
import { useTheme } from '../ThemeContext';
import { EXISTING_ACCOUNT_MESSAGE } from '../shared/agentSignup';

function linkStyle(color) {
  return {
    background: 'none',
    border: 'none',
    padding: 0,
    color,
    font: 'inherit',
    fontWeight: 650,
    textDecoration: 'underline',
    cursor: 'pointer',
  };
}

function ExistingAccountNotice({ onSignIn, onForgotPassword }) {
  const { colors } = useTheme();
  return (
    <div role="alert" style={{ margin: '0 0 1rem', textAlign: 'left', color: colors.text }}>
      <p style={{ margin: '0 0 0.5rem', lineHeight: 1.45 }}>{EXISTING_ACCOUNT_MESSAGE}</p>
      <p style={{ margin: 0 }}>
        <button type="button" onClick={onSignIn} style={linkStyle(colors.primary)}>Sign in</button>
        <span style={{ color: colors.textSecondary }}> · </span>
        <button type="button" onClick={onForgotPassword} style={linkStyle(colors.primary)}>Forgot password</button>
      </p>
    </div>
  );
}

export default ExistingAccountNotice;
